'use client';

import { useLocale } from 'next-intl';
import React from 'react';

import { IMAGE_QUALITY_SOUS_UNIVERS_CARD } from '@/constants/image-quality';
import type {
  Meilisearch_SousUnivers,
  Meilisearch_Univers,
} from '@/lib/api/meilisearch-types';
import { getLocalizedPathName } from '@/proxy';
import type { SousUnivers, Univers } from '@/types/new-directus-types';
import type { PossibleLocales } from '@/utils/AppConfig';

import { GenericCard } from '../../../home-components/GenericCard';
import { translate } from '../[sous_univers_slug]/[livreSlug]/utils/translate';
// import { UniverseCard } from '../../../home-components/UniverseCard';

type MeilisearchSousUniversCardProps = {
  sousUnivers: Meilisearch_SousUnivers;
  univers: Meilisearch_Univers;
  showUniverseName?: boolean;
};

export const MeilisearchSousUniversCard: React.FC<
  MeilisearchSousUniversCardProps
> = ({ sousUnivers, univers, showUniverseName = false }) => {
  const locale = useLocale() as PossibleLocales;

  const universeName = React.useMemo(() => {
    if (showUniverseName) {
      return univers[locale].nom;
    }
    return undefined;
  }, [univers, showUniverseName, locale]);

  return (
    <GenericCard
      href={`${getLocalizedPathName('/oeuvres', locale)}/${univers[locale].slug}/${sousUnivers[locale].slug}`}
      imageAlt={sousUnivers[locale].nom_sous_univers}
      // TODO: refactor this
      imageId={sousUnivers.miniature_carree as unknown as string}
      quality={IMAGE_QUALITY_SOUS_UNIVERS_CARD}
      sourceDpr={2}
      key={sousUnivers[locale].slug}
      // hideUniverse
      preTitle={universeName}
      title={sousUnivers[locale].nom_sous_univers}
      // subTitle={sousUnivers.nom_sous_univers}
      contentWrapperClassName="pb-0"
      square
    />
  );
};
type DirectusSousUniversCardProps = {
  sousUnivers: SousUnivers;
  univers: Univers;
  showUniverseName?: boolean;
  imagesPath?: '/images' | '/related-images';
};

export const DirectusSousUniversCard: React.FC<
  DirectusSousUniversCardProps
> = ({
  sousUnivers,
  univers,
  showUniverseName = false,
  imagesPath = '/images',
}) => {
  const locale = useLocale() as PossibleLocales;

  const universeName = React.useMemo(() => {
    if (showUniverseName) {
      return translate(
        univers,
        'nom_fr',
        'nom_en',
        locale,
        univers.nom_fr,
      ) as string;
    }
    return undefined;
  }, [univers, showUniverseName, locale]);

  return (
    <GenericCard
      imagesPath={imagesPath}
      href={`${getLocalizedPathName('/oeuvres', locale)}/${translate(univers, 'slug_fr', 'slug_en', locale, univers.slug_fr)}/${translate(sousUnivers, 'slug_fr', 'slug_en', locale, sousUnivers.slug_fr)}`}
      imageAlt={
        translate(univers, 'nom_fr', 'nom_en', locale, univers.nom_fr) as string
      }
      // TODO: refactor this
      imageId={sousUnivers.miniature_carree as unknown as string}
      quality={IMAGE_QUALITY_SOUS_UNIVERS_CARD}
      sourceDpr={2}
      key={translate(
        sousUnivers,
        'slug_fr',
        'slug_en',
        locale,
        sousUnivers.slug_fr,
      )}
      // hideUniverse
      preTitle={universeName}
      title={
        translate(
          sousUnivers,
          'nom_sous_univers',
          'nom_sous_univers_en',
          locale,
          sousUnivers.nom_sous_univers,
        ) as string
      }
      // subTitle={sousUnivers.nom_sous_univers}
      contentWrapperClassName="pb-0"
      square
    />
  );
};
